import type {
    ConnectedAccountResponse,
    ConnectedAccountRequest,
    OAuthProviderType,
} from 'owa-link-account';
import { addCalendarProviderAccount as addCalendarProviderAccountService } from '../services/addCalendarProviderAccount';
import type { CalendarProviderAccountInfo } from '../types/CalendarProviderAccountInfo';

export interface ConnectedAccountResponseWithObj<T> extends ConnectedAccountResponse {
    connectedAccountObject: T;
}

export function addCalendarProviderAccountHandler(providerType: OAuthProviderType) {
    return async (request: ConnectedAccountRequest) => {
        const response = await addCalendarProviderAccountService(request);

        const connectedAccountResponse: ConnectedAccountResponseWithObj<CalendarProviderAccountInfo> = {
            providerType: providerType,
            token: null,
            userAccount: response.calendarProviderAccount.userAccount,
            connectedAccountObject: response.calendarProviderAccount,
        };

        return connectedAccountResponse;
    };
}
